import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight, Phone } from "lucide-react";
import { PHONE, PHONE_LABEL } from "@/lib/api";

const LINES = ["POWER THAT", "NEVER", "STOPS."];
const HERO_IMG = "https://images.unsplash.com/photo-1720036237390-7cec3edda585?auto=format&fit=crop&w=1600&q=90";

const MaskLine = ({ children, delay }) => (
  <span className="mask-line">
    <motion.span initial={{ y: "112%" }} animate={{ y: "0%" }}
      transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1], delay }}>{children}</motion.span>
  </span>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 140]);
  return (
    <section id="home" className="hero" ref={ref}>
      <div className="hero-copy">
        <motion.p className="eyebrow" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.9, duration: 0.8 }}>
          M/S KRISHNA GENERATOR SERVICE — GUWAHATI, ASSAM
        </motion.p>
        <h1 className="hero-title">
          {LINES.map((l, i) => (
            <MaskLine key={l} delay={0.15 + i * 0.13}>
              {i === 2 ? <em>{l}</em> : l}
            </MaskLine>
          ))}
        </h1>
        <motion.p className="hero-sub" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.85, duration: 0.8 }}>
          Diesel generator sets on rent — delivered, installed and maintained by people who treat your downtime as their emergency.
        </motion.p>
        <motion.div className="hero-actions" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1, duration: 0.8 }}>
          <a data-testid="hero-quote-button" href="#booking" className="btn btn-amber">Book a DG set <ArrowUpRight size={17} /></a>
          <a data-testid="hero-call-link" href={`tel:${PHONE}`} className="btn btn-ghost"><Phone size={16} /> {PHONE_LABEL}</a>
        </motion.div>
        <motion.div className="hero-stats" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2, duration: 0.9 }}>
          <div className="stat"><strong>15–500</strong><span>kVA fleet range</span></div>
          <div className="stat"><strong>24/7</strong><span>breakdown response</span></div>
          <div className="stat"><strong>100%</strong><span>pre-dispatch tested</span></div>
        </motion.div>
      </div>
      <motion.div className="hero-media" initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.3, ease: [0.76, 0, 0.24, 1], delay: 0.35 }}>
        <div className="hero-frame">
          <motion.img data-testid="hero-generator-image" style={{ y }} src={HERO_IMG} alt="Industrial diesel generator facility" />
          <div className="hero-spot" />
          <div className="hero-badge"><span className="live-dot" /> UNITS AVAILABLE — DEPLOY TODAY</div>
        </div>
      </motion.div>
    </section>
  );
};
